// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3QfGd","footer":"ReportModalFilter_footer__3cUap"};